export default __webpack_public_path__ + "static/media/2230.53fcaed4.png";